export default __webpack_public_path__ + "static/media/SettingsIllustration.07e7bad8.png";